interface DividerProps {
  children?: React.ReactNode;
  className?: string;
}

export function Divider({ children, className = "" }: DividerProps) {
  if (children) {
    return (
      <div className={`flex items-center ${className}`}>
        <div className="flex-grow h-[1px] bg-gray-200" />
        <div className="px-3">{children}</div>
        <div className="flex-grow h-[1px] bg-gray-200" />
      </div>
    );
  }

  return <div className={`h-[1px] bg-gray-200 ${className}`} />;
} 